import React, { useMemo } from 'react';

import CodeMirrorPreview from '@dashboard/components/CodeMirror/CodeMirrorPreview';

type TType = 'NODE' | 'CURL';
type Props = {
  type: TType;
  workflowKey: null | string | undefined;
  workflowId: string;
};

type ApiProps = {
  url: string;
  data: Record<string, unknown>;
};

function getCodeExample(type: TType, { url, data }: ApiProps): string {
  switch (type) {
    case 'CURL':
      return `curl "${url}" \\
  -H 'Content-Type: application/json' \\
  -u 'USERNAME:PASSWORD' \\
  -d '${JSON.stringify(data, null, '  ')}'`;
    case 'NODE': {
      const payload = {
        headers: { 'Content-Type': 'application/json' },
        method: 'post',
        url,
        auth: { username: 'USERNAME', password: 'PASSWORD' },
        data,
      };
      return `const axios = require('axios');

axios(${JSON.stringify(payload, null, '  ')})
.then(function (response) {
  console.log(response);
})
.catch(function (error) {
  console.log(error);
})`;
    }
  }
}

export default function CodeExample({ type, workflowKey, workflowId }: Props) {
  const codeExample = useMemo(() => {
    let data: Record<string, unknown> = {
      workflowId,
      variables: {
        user: {
          name: 'Susie Sampler',
          email: 'susie@sampler.com',
        },
      },
    };
    if (workflowKey) {
      data = {
        workflowKey,
        variables: {
          user: {
            name: 'Susie Sampler',
            email: 'susie@sampler.com',
          },
        },
      };
    }
    return getCodeExample(type, { url: `https://live.waypointapi.com/v1/workflow_runs`, data });
  }, [type, workflowKey, workflowId]);

  return <CodeMirrorPreview key={codeExample} language="JSON" value={codeExample} />;
}
